import { Injectable } from '@angular/core';
import { BackendService } from './general/backend.service';
import { ProjectReport, ProjectReportsResponse } from '../models/project-report.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectReportService {
  constructor(private backend: BackendService) {}

  list(
    projectId: string | number,
    success_callback: (data: ProjectReportsResponse) => void = () => {},
    error_callback: (error: any) => void = () => {},
  ) {
    this.backend.get(`project/${projectId}/reports`).subscribe(
      (result: any) => success_callback(result),
      (error) => {
        this.backend.showErrors(error);
        error_callback(error);
      },
    );
  }

  create(
    projectId: string | number,
    payload: { title: string; notes: string; file: File },
    success_callback: (data: ProjectReport) => void = () => {},
    error_callback: (error: any) => void = () => {},
  ) {
    this.backend.postFormData(`project/${projectId}/reports`, this.buildFormData(payload)).subscribe(
      (result: any) => success_callback(result),
      (error) => {
        this.backend.showErrors(error);
        error_callback(error);
      },
    );
  }

  update(
    projectId: string | number,
    reportId: number,
    payload: { title: string; notes: string; file?: File | null },
    success_callback: (data: ProjectReport) => void = () => {},
    error_callback: (error: any) => void = () => {},
  ) {
    this.backend.postFormData(`project/${projectId}/reports/${reportId}`, this.buildFormData(payload)).subscribe(
      (result: any) => success_callback(result),
      (error) => {
        this.backend.showErrors(error);
        error_callback(error);
      },
    );
  }

  remove(
    projectId: string | number,
    reportId: number,
    success_callback: () => void = () => {},
    error_callback: (error: any) => void = () => {},
  ) {
    this.backend.destroy(`project/${projectId}/reports/${reportId}`).subscribe(
      () => success_callback(),
      (error) => {
        this.backend.showErrors(error);
        error_callback(error);
      },
    );
  }

  openFile(
    projectId: string | number,
    reportId: number,
    error_callback: (error: any) => void = () => {},
  ) {
    const newTab = window.open('', '_blank');

    this.backend.getBlob(`project/${projectId}/reports/${reportId}/file`).subscribe(
      (result: any) => {
        const url = URL.createObjectURL(result.body ?? result);
        if (newTab) {
          newTab.location.href = url;
        } else {
          window.open(url, '_blank');
        }
      },
      (error) => {
        newTab?.close();
        this.backend.showErrors(error);
        error_callback(error);
      },
    );
  }

  private buildFormData(payload: { title: string; notes: string; file?: File | null }): FormData {
    const formData = new FormData();
    formData.append('title', payload.title ?? '');
    formData.append('notes', payload.notes ?? '');
    if (payload.file) {
      formData.append('file', payload.file);
    }
    return formData;
  }
}
